// Service worker registration (production builds only) and the install prompt
// of Chromium browsers.
import { useSyncExternalStore } from 'react';

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let installEvent: BeforeInstallPromptEvent | null = null;
const listeners = new Set<() => void>();
const notify = () => {
  for (const listener of listeners) listener();
};

window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault();
  installEvent = event as BeforeInstallPromptEvent;
  notify();
});
window.addEventListener('appinstalled', () => {
  installEvent = null;
  notify();
});

export function useInstallAvailable(): boolean {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => installEvent !== null,
  );
}

export async function promptInstall(): Promise<void> {
  const event = installEvent;
  if (!event) return;
  await event.prompt();
  await event.userChoice.catch(() => undefined);
  installEvent = null;
  notify();
}

export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => console.warn('[pwa] service worker registration failed', error));
  });
}
